import {
    FocusLayerSizeV2,
    LayerHandleV2,
    LayerManagerV2,
} from '@volkswagen-onehub/layer-manager'
import React from 'react'
import {Provider} from 'react-redux'
import store from '../../store'
import {ExternalLinkPopUpLayer} from '../ExternalLinkPopUpLayer'

function ExternalLinkPopUpRenderLayer(): React.JSX.Element {
    return (
        <Provider store={store}>
            <ExternalLinkPopUpLayer />
        </Provider>
    )
}

let localLayerManager: LayerManagerV2
let layer: LayerHandleV2<{message: string | undefined}>

export const setExternalLinkPopUpLayerHandle = (
    layerManager: LayerManagerV2
) => {
    localLayerManager = layerManager
}

export const openExternalLinkPopUpLayer = () => {
    layer = localLayerManager.openFocusLayer(
        ExternalLinkPopUpRenderLayer,
        {},
        {userCloseable: true, size: FocusLayerSizeV2.A}
    )
}

export const closeExternalLinkPopUpLayer = () => {
    if (layer) {
        layer.close()
    }
}
